import { retrieveUser } from "../api/retrieveUser.js";

/**
 * Retrieve the user from the backend.  If the user has
 * been disabled, return will be {}
 * @param {} param0
 * @returns
 */
export default async function userLoader({ params }) {
  //TODO: Probably don't need this line anymore....
  //const username = params.username === 'interiordesignerella1'? 'interiordesignerella' : params.username;
  const username = params.username;

  const dirtyUser = await retrieveUser(username.toLowerCase());

  console.log(dirtyUser);
  if (dirtyUser === "{}") {
    return undefined;
  } else {
    const dirtyUserButtonList = dirtyUser.data.Item.userButtonList;
    const cleanUserButtonList = dirtyUserButtonList.map((item) => {
      return {
        buttonId: item.SK.S,
        url: item.url.S,
        text: item.text.S,
        order: parseInt(item.order.N, 10),
      };
    });

    const profilePicObjectKey = dirtyUser.data.Item.profilePicObjectKey;
    const welcome = dirtyUser.data.Item.welcome || "";
    const profilePicUrl =
      profilePicObjectKey !== undefined
        ? `https://${process.env.REACT_APP_DOMAIN}/${profilePicObjectKey}`
        : undefined;

    // Empty string means the user has no background (or removed it).
    const backgroundImageObjectKey = dirtyUser.data.Item.backgroundImageObjectKey;
    const backgroundImageUrl = backgroundImageObjectKey
      ? `https://${process.env.REACT_APP_DOMAIN}/${backgroundImageObjectKey}`
      : undefined;

    // Only a strict #rrggbb reaches the page style; empty or anything else means the default.
    const hexColor = (value) => (/^#[0-9a-fA-F]{6}$/.test(value || "") ? value : undefined);
    const backgroundColor = hexColor(dirtyUser.data.Item.backgroundColor);

    const cleanUser = {
      userButtonList: cleanUserButtonList,
      userId: dirtyUser.data.Item.PK,
      username: dirtyUser.data.Item.username || "",
      profilePicUrl: profilePicUrl,
      backgroundImageUrl: backgroundImageUrl,
      backgroundColor: backgroundColor,
      welcome: welcome,
      profilePageDisclosure: dirtyUser.data.Item.profilePageDisclosure || "",
      subImageLinksAction: dirtyUser.data.Item.subImageLinksAction || "",
      subImageLinksDisclosure:
      dirtyUser.data.Item.subImageLinksDisclosure || "",
      fbEnabled: dirtyUser.data.Item.igStatus === "enabled",
      tiktokEnabled: dirtyUser.data.Item.tiktokStatus === "enabled",
      metaPixelId: dirtyUser.data.Item.metaPixelId,
      base_subscription: dirtyUser.data.Item.base_subscription,
      igAspectRatio: dirtyUser.data.Item.igAspectRatio,
      metaPixelAllowed: dirtyUser.data.Item.metaPixelAllowed || false,
      // Checked against the allowed fonts and sizes in siteStyle.js.
      handleFont: dirtyUser.data.Item.handleFont || "",
      buttonFont: dirtyUser.data.Item.buttonFont || "",
      tabFont: dirtyUser.data.Item.tabFont || "",
      ctaFont: dirtyUser.data.Item.ctaFont || "",
      handleSize: dirtyUser.data.Item.handleSize || "",
      buttonSize: dirtyUser.data.Item.buttonSize || "",
      tabSize: dirtyUser.data.Item.tabSize || "",
      ctaSize: dirtyUser.data.Item.ctaSize || "",
      ctaPosition: dirtyUser.data.Item.ctaPosition || "",
      buttonColor: hexColor(dirtyUser.data.Item.buttonColor),
      handleColor: hexColor(dirtyUser.data.Item.handleColor),
      buttonTextColor: hexColor(dirtyUser.data.Item.buttonTextColor),
      tabColor: hexColor(dirtyUser.data.Item.tabColor),
      ctaColor: hexColor(dirtyUser.data.Item.ctaColor),
    };
    return cleanUser;
  }
}
